import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fdb8bae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Card" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  class: "row",
  style: {"gap":"5px"}
}
const _hoisted_5 = { class: "col d-flex flex-column justify-content-center align-item-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Manifiestos")
], -1))
const _hoisted_7 = { class: "card overflow-scroll" }
const _hoisted_8 = { class: "table table-hover table-sm" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", null, "Operador"),
    /*#__PURE__*/_createElementVNode("th", null, "No. Vuelo"),
    /*#__PURE__*/_createElementVNode("th", null, "Pto. Despacho"),
    /*#__PURE__*/_createElementVNode("th", null, "Pto. Destino"),
    /*#__PURE__*/_createElementVNode("th", null, "Aeronave"),
    /*#__PURE__*/_createElementVNode("th", null, "Matrícula"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Air Way Bill por Manifiestos")
], -1))
const _hoisted_12 = { class: "card overflow-scroll" }
const _hoisted_13 = { class: "table table-hover table-sm" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Secuencia"),
    /*#__PURE__*/_createElementVNode("th", null, "No. Embarque"),
    /*#__PURE__*/_createElementVNode("th", null, "Naturaleza"),
    /*#__PURE__*/_createElementVNode("th", null, "Tot. Piezas"),
    /*#__PURE__*/_createElementVNode("th", null, "Peso Kg."),
    /*#__PURE__*/_createElementVNode("th", null, "Destinatario"),
    /*#__PURE__*/_createElementVNode("th", null, "Ubicación"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  class: "col div-buttom",
  style: {"background-color":"rgba(255, 255, 255, 0.3)","backdrop-filter":"blur(10px)","border-radius":"10px","height":"300px"}
}
const _hoisted_17 = { class: "btn-group2" }
const _hoisted_18 = ["disabled"]

import { ref, onMounted, computed, Ref } from 'vue';
import axios from 'axios';
import { useAlert } from '@/store/useAlert';
import { UrlGlobal } from '@/store/dominioGlobal';
import { Carcmani, Cardmani } from '@/interface/interfaces';
import UpConfirma from './pUpdate/UpConfirma.vue';
import UpComplemento from './pUpdate/UpComplemento.vue';
import UpVercalculo from './UpVercalculo.vue';
import { flattenDiagnosticMessageText } from 'typescript';


export default /*#__PURE__*/_defineComponent({
  __name: 'CtrlManifiesto',
  setup(__props) {

 
const {success, error, question,warning} = useAlert()
const dUrl = UrlGlobal()
const search = ref('')
const options = ref('')
const id_ref = ref<string | null>(null)
const de_ref = ref<string | null>(null)
const id_status = ref<string | null>(null)
//--------------------------------------------------------------------------------------------------------------
const carcmani = ref<Array<Carcmani>>([]);

const getCarcmani = () => { 
        axios.get(dUrl.urlGlobal +'/api2/carcmani/')
            .then(response => {
                carcmani.value = response.data;
        
            let fecha = response.data.fecha
            let operador = response.data.operador
            let numero_vuelo = response.data.numero_vuelo
            

            })
            .catch(error => {
                console.error('Error buscando control de Manifiestos:', error);
            });
};
const getCardmaniId = (id: any, sts: any, emb: any, novue: any, opera: any, fec: any) => {
  de_ref.value = id
  id_status.value = sts
  no_embarque = emb
  numero_vuelo = novue
  operador = opera
  fecha = fec 

  if(!de_ref.value) {
    return
  }

}
//----------------------------------------------------------------
const cardmani = ref<Array<Cardmani>>([])
const getCardmani = (id_numero_vuelo: any, id_operador: any, id_fecha: any, id: any, nom_opera: any) => {
        id_ref.value = id
        fecha = id_fecha
        operador = id_operador
        numero_vuelo = id_numero_vuelo
        nom_operador = nom_opera
        de_ref.value = null

        axios.get(`${dUrl.urlGlobal}/api2/carcmani/cardmani?id_numero_vuelo=${id_numero_vuelo}&id_operador=${id_operador}&id_fecha=${id_fecha}`)
        //axios.get(final)    
            .then(response => { //console.log(response.data)
                cardmani.value = response.data;
                console.log(response.data)

                
            })
            .catch(error => {
                console.error('Error buscando detalles de manifiesto:', error);
        });
    }
//};
//funcion de los botones y las extenciones de Insert,delete,update----------------
let fecha: any
let operador: any
let numero_vuelo: any
let no_embarque: any
let nom_operador: any

let btnUp = ref(false);//variable para mostrar modal de update
let clickUp = ref(false)//variable para activar el click de Up
let btnCoUp = ref(false)
let clickCoUp = ref(false)
let btnCaUp = ref(false)
let clickCaUp = ref(false)

    

//funciones q activan el click y en el caso del insert muestran el modal
const CbtnUp = () => {
  clickUp.value = !clickUp.value
   
}
function updatePropsValue(newValue: boolean) {
  btnUp.value = newValue
  getCarcmani()
  getCardmani(numero_vuelo, operador, fecha, null,null)
}

function updateCoPropsValue(newValue: boolean) {
  btnCoUp.value = newValue

  getCarcmani()
  getCardmani(numero_vuelo, operador, fecha, null, null)
}

function updateCaPropsValue(newValue: boolean) {
  btnCaUp.value = newValue

  getCarcmani()
  getCardmani(numero_vuelo, operador, fecha, null, null)
}
//--- Fun//funcion principal para el funcionamiento de el update y delete cuando uno de los 2 este activado
const FunClick = (n: any, nm: any, st: any) => {
  fecha = n;
  operador = nm;
  numero_vuelo = st;

  if (clickUp.value == true) {
    btnUp.value = !btnUp.value
    clickUp.value = !clickUp.value
  }
}
  //-- Funciones de Botones
const Calcular = async() => {
  let calcular = true
  if (!de_ref.value) {
    return
  }

  if (id_status.value =='K' || id_status.value =='C') {
    null
  } else {
    return
  }
    
  const result = await question(
    'Se generarán los calculos de la Guía',
    '¿Seguro desea continuar?'
  )

  if (!result.isConfirmed) {
    // Usuario canceló, salimos de la función
    return
  }

  axios.get(`${dUrl.urlGlobal}/api2/carcmani/calculo?id=${de_ref.value}`) 
    .then(response => {
      console.log("Generado")
      getCarcmani
      getCardmani(numero_vuelo, operador, fecha, null, null)
    })
    .catch(error => {
      console.log('Error calculando:', error)
    })
}

const Vercalculo = () => {
  if (!de_ref.value) {
    return
  }

  if (id_status.value !='C') {
    return
  }

  clickCaUp.value = !clickCaUp.value

  if (clickCaUp.value == true) {
      btnCaUp.value = !btnCaUp.value
      clickCaUp.value = !clickCaUp.value
  }
}

const Confirmar = () => {
  if (!de_ref.value) {
    return
  }

  if (id_status.value != 'R' && id_status.value !='L') {
    return
  }

  clickUp.value = !clickUp.value

  if (clickUp.value == true) {
    btnUp.value = !btnUp.value
    clickUp.value = !clickUp.value
  } 
}

const Complemento = () => {
   if (!de_ref.value) {
    return
  }
  //'L' es Confirmado
  if (id_status.value == 'C' || id_status.value =='R' || id_status.value =='D') {
    return
  }

  clickCoUp.value = !clickCoUp.value

  if (clickCoUp.value == true) {
    btnCoUp.value = !btnCoUp.value
    clickCoUp.value = !clickCoUp.value
  }
}

const Listar = () => {
  let calcular = false
}

const Anular = () => {
  let calcular = false
}

//-----------------------------------------------------------------
// Filtrar los registros que coincidan con el valor de búsqueda en cualquiera de los campos segun la tabla------------------------------------------------
const filteredCarga1 = computed(() => {
    if (search.value === '') {
        // Si no hay nada en la búsqueda, retornar todos los registros
        return carcmani.value;
    } else if (options.value == 'fecha') {
        // Convertir el término de búsqueda a minúsculas para hacer la búsqueda insensible a mayúsculas
        const searchTerm = search.value.toLowerCase();
        // Filtrar los registros que coincidan con el valor de búsqueda en cualquiera de los campos
        return carcmani.value.filter(elm => {
            return (
                elm.fecha?.toLowerCase().includes(searchTerm) ||
                elm.nom_operador?.toLowerCase().includes(searchTerm) ||
                elm.numero_vuelo?.toLowerCase().includes(searchTerm) ||
                elm.nom_pto_despacho?.toLowerCase().includes(searchTerm) ||
                elm.nom_pto_destino?.toLowerCase().includes(searchTerm) ||
                //elm.tot_piezas?.toLowerCase().includes(searchTerm) ||
                //elm.peso_kg?.toLowerCase().includes(searchTerm) ||
                elm.nom_aeronave?.toLowerCase().includes(searchTerm) ||
                elm.matricula?.toLowerCase().includes(searchTerm) ||
                elm.nom_status?.toLowerCase().includes(searchTerm)
            );
        });
    }else{
        return carcmani.value
    }
});
//-----------------------------------------------------------------
const filteredCarga2 = computed(() => {
    if (search.value === '') {
        return cardmani.value;

    } else if (options.value == 'Cardmani') {
        const searchTerm = search.value.toLowerCase();

        console.log(de_ref.value)

        return cardmani.value.filter(elm1 => {
            return (
                elm1.fecha?.toLocaleLowerCase().includes(searchTerm) ||
                elm1.operador?.toLocaleLowerCase().includes(searchTerm) ||
                elm1.numero_vuelo?.toLocaleLowerCase().includes(searchTerm) ||
                elm1.no_embarque?.toLowerCase().includes(searchTerm)
                
            );
        });
    }else{
        return cardmani.value
    }
});

//const FunClick = (fe: any, op: any, nv: any) => {
//  let fecha = fe;
//  let operador = op;
//  let numero_vuelo = nv;
   
//----------------------------------------------------------------
// Estado del formulario y la data
//const formData = ref({
//  base_datos: '',
//  tipo_base_datos: '',
//  servidor_bdatos: '',
//  hostname: '',
//  ip_address: '',
//  servicio: '',
//  puerto: '',
//  protocolo: ''
//});

// Variables de control
const dataList = ref<any[]>([]); // Lista de datos de la API
const currentIndex = ref(0);
const isEditing = ref(false);
const isSearching = ref(false);
const isInserting = ref(false);
const isDeleting = ref(false);
const canNavigate = ref(false);
const onlyRead = ref(true);
const ButtonText = ref('Conf')
const ButtonText2 = ref('Complto')
const ButtonText3 = ref('Calcula')
const ButtonText4 = ref('Anular')

// Deshabilita los botones de btn-group2 si no está en modo búsqueda o insercion
const canUseGroup2 = computed(() => isSearching.value || isInserting.value || isEditing.value || isDeleting.value);

//boton principal que controla el submit

//------------------------------------------------------------------------------------------------------------------
onMounted(() => {
    getCarcmani();
    console.log(carcmani)
    getCardmani(null, "1", "1",null, null);
  
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCarga1.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.numero_vuelo,
                        onClick: ($event: any) => (getCardmani(elm.numero_vuelo, elm.operador, elm.fecha, elm.id, elm.nom_operador)),
                        class: _normalizeClass({ 'table-primary': elm.id === id_ref.value })
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.fecha), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_operador), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.numero_vuelo), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_pto_despacho), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_pto_destino), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_aeronave), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.matricula), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_status), 1)
                      ], 10, _hoisted_10))
                    }), 128))
                  ])
                ])
              ]),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCarga2.value, (elm1) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm1.no_embarque,
                        onClick: ($event: any) => (getCardmaniId(elm1.id, elm1.status, elm1.no_embarque, elm1.numero_vuelo,
                                                       elm1.operador, elm1.fecha)),
                        class: _normalizeClass({ 'table-primary': elm1.id === de_ref.value })
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm1.secuencia), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.no_embarque), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.nom_naturaleza), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.cant_items), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.peso_kg), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.destinatario), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.ubicacion), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.nom_status), 1)
                      ], 10, _hoisted_15))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: _withModifiers(Confirmar, ["prevent"])
                }, "Confirmar"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: Complemento
                }, "Liquidación"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: Calcular
                }, "Calcular"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: Vercalculo,
                  disabled: ""
                }, "Ver Calculo"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: Listar,
                  disabled: !canUseGroup2.value
                }, "Listar", 8, _hoisted_18)
              ])
            ])
          ])
        ]),
        (_unref(btnUp))
          ? (_openBlock(), _createBlock(UpConfirma, {
              key: 0,
              fecha: _unref(fecha),
              operador: _unref(operador),
              numero_vuelo: _unref(numero_vuelo),
              no_embarque: _unref(no_embarque),
              nom_operador: _unref(nom_operador),
              btnUp: _unref(btnUp),
              onUpdateProps: updatePropsValue
            }, null, 8, ["fecha", "operador", "numero_vuelo", "no_embarque", "nom_operador", "btnUp"]))
          : _createCommentVNode("", true),
        (_unref(btnCoUp))
          ? (_openBlock(), _createBlock(UpComplemento, {
              key: 1,
              fecha: _unref(fecha),
              operador: _unref(operador),
              numero_vuelo: _unref(numero_vuelo),
              no_embarque: _unref(no_embarque),
              btnCoUp: _unref(btnCoUp),
              onUpdateCoProps: updateCoPropsValue
            }, null, 8, ["fecha", "operador", "numero_vuelo", "no_embarque", "btnCoUp"]))
          : _createCommentVNode("", true),
        (_unref(btnCaUp))
          ? (_openBlock(), _createBlock(UpVercalculo, {
              key: 2,
              fecha: _unref(fecha),
              operador: _unref(operador),
              numero_vuelo: _unref(numero_vuelo),
              no_embarque: _unref(no_embarque),
              btnCaUp: _unref(btnCaUp),
              onUpdateProps: updateCaPropsValue
            }, null, 8, ["fecha", "operador", "numero_vuelo", "no_embarque", "btnCaUp"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})